import { render, staticRenderFns } from "./BzImageSubmission.vue?vue&type=template&id=0ff1bded&scoped=true&"
import script from "./BzImageSubmission.vue?vue&type=script&lang=js&"
export * from "./BzImageSubmission.vue?vue&type=script&lang=js&"
import style0 from "./BzImageSubmission.vue?vue&type=style&index=0&id=0ff1bded&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff1bded",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCol,VDialog,VIcon,VImg,VRow})
